import * as tslib_1 from "tslib";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import UserAvatarTooltipContent from './UserAvatarTooltipContent';
import TooltipOnHover from '../../Tooltip/TooltipOnHover';
import TextTooltipOnHover from '../../Tooltip/TextTooltipOnHover';
import Flag from '../../redux/flags/Flag';
import { ThemeOptions } from '../../publicSession/types';
import { BiContext, BiLoggerContextProvider, } from '../../biLogger';
import { withLogBiEvent, } from '../../biLogger/hocs/withLogBiEvent';
import UserAvatarTooltipButtonsContext from './UserAvatarTooltipButtonsContext';
import { withMobileContext } from '../../Context';
import s from './UserAvatarTooltip.scss';
var HOVER_DELAY = 1000;
export var UserAvatarTooltip = function (props) {
    var TooltipContent = function () {
        var data = props.data, isError = props.isError, isOwner = props.isOwner, useV2 = props.useV2;
        var biContext = useContext(BiContext);
        var withButtons = useContext(UserAvatarTooltipButtonsContext);
        if (isError || !data) {
            return null;
        }
        return (React.createElement("div", { className: classnames(s['tooltip'], (!withButtons || isOwner) && s['without-buttons']) }, !isError && data && (React.createElement(BiLoggerContextProvider, { value: {
                widgetname: 'user_popup',
                sectionname: biContext.sectionname && biContext.sectionname + "_popup",
            } },
            React.createElement(UserAvatarTooltipContent, tslib_1.__assign({ useV2: useV2, withButtons: !isOwner && withButtons }, data))))));
    };
    var onVisible = function () {
        if (props.biData) {
            props.logBiEvent(props.biData);
        }
        if (!props.isInitialized) {
            props.initialize(props.username);
        }
    };
    var children = props.children, className = props.className, isMobile = props.isMobile, data = props.data;
    if (isMobile) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(Flag, { condition: "tooltips_ui_updates", render: function () { return (React.createElement(TooltipOnHover, { className: className, contentClassName: s['tooltip-content-v2'], arrowClassName: s['tooltip-arrow-v2'], tooltipContent: React.createElement(TooltipContent, null), noPadding: true, hoverDelay: HOVER_DELAY, isOpen: !!data, onVisible: onVisible, forceTheme: ThemeOptions.DARK }, children)); }, fallbackRender: function () { return (React.createElement(TextTooltipOnHover, { className: className, contentClassName: s['tooltip-content'], arrowClassName: s['tooltip-arrow'], tooltipText: React.createElement(TooltipContent, null), noPadding: true, hoverDelay: HOVER_DELAY, isOpen: !!data, onVisible: onVisible, forceTheme: ThemeOptions.DARK }, children)); } }));
};
export default compose(withMobileContext, withLogBiEvent)(UserAvatarTooltip);
//# sourceMappingURL=UserAvatarTooltip.js.map